<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2025-08-20 09:40:19
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-08-22 11:07:28
 * @FilePath: /epec-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/supplierListMaintenance/components/addSingleSupplierDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <e-dialog
      popup-width="600px"
      dialog-title="添加供应商"
      :center-dialog-visible="addSingleSupplierVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="importSubmitPopupData('ruleForm')"
    >
      <el-form
        ref="uploadForm"
        size="small"
        :model="dialogData"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item
          label="供应商名称:"
          label-width="160px"
          prop="subCompanyName"
        >
          <el-autocomplete
            v-model="dialogData.subCompanyName"
            style="width: 100%"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入供应商名称"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item
          label="上传供应商评价报告:"
          label-width="160px"
          prop="ossUrl"
        >
          <eui-upload
            ref="upload"
            :file-list="fileArr"
            :action="url"
            :headers="headers"
            :show-file-list="true"
            :limit="1"
            text="选择上传"
            tip="附件格式不限，每个附件大小不超过200M"
            :limit-file-size="200"
            @handleSuccess="uploadSuccess"
          ></eui-upload>
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import { epecToken } from '@/modules/projectA/utils/globalData';
import utils from '@/modules/projectA/utils/utils';
import api from '@/modules/projectA/api/user';

export default {
  components: {
    eDialog,
  },
  props: {
    addSingleSupplierVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      autoUpload: false,
      fileList: [],
      fileArr: [],
      uploadLoading: false,
      headers: epecToken,
      downloadUrl: '',
      privateUpload: {},
      url: api.fileUploadForSubSupplier,
      dialogData: {
        subCompanyName: '',
        subCompanyId: '',
        fileName: '',
        ossUrl: '',
      },
      rules: {
        subCompanyName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' },
          { max: 255, message: '供应商名称不能超过255个字符', trigger: 'blur' },
        ],
        ossUrl: [
          {
            required: true,
            message: '请上传供应商评价报告',
            trigger: ['blur', 'change'],
          },
        ],
      },
    };
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      const res = await api.querySubSupplierByName({
        companyName: queryString,
      });
      if (res.code === '200') {
        cb(
          res.data.map((item) => ({
            value: item.companyName,
            label: item.companyId,
          }))
        );
      }
    },
    importSubmitPopupData() {
      this.$refs.uploadForm.validate(async (valid) => {
        if (valid) {
          const res = await api.addSubSupplier(this.dialogData);
          if (res.code === '200') {
            this.$message.success('添加供应商成功。');
            this.$emit('handleAddSupplier');
          }
        }
      });
    },
    handleSelect(item) {
      console.log(item);
      this.dialogData.subCompanyId = item.label;
      this.dialogData.subCompanyName = item.value;
    },
    resetPopupData() {
      this.$emit('update:addSingleSupplierVisible', false);
    },
    uploadSuccess(res) {
      if (res.code === '200') {
        this.$message.success('文件上传成功。');
        this.dialogData.fileName = res.data.fileName;
        this.dialogData.ossUrl = res.data.url;
        // 重新触发校验
        this.$refs.uploadForm.validateField('ossUrl');
      } else {
        this.$message.warning(res.message);
      }
    },
  },
};
</script>
